import React from 'react';
import { Container, ListGroup, ListGroupItem } from 'reactstrap';

import SEO from 'shared/components/SEO';
import { companies } from '../config';

function Privacy() {
  const {
    title,
    location: { street, number, postalCode, city },
    contact: { email },
  } = companies.dranken;

  return (
    <Container className="mt-4">
      <SEO
        title="Privacy policy"
        description="Deze privacy policy regelt de verwerking van je persoonsgegevens als een onderdeel van je gebruik van onze website en de diensten die daarmee verband houden."
        canonical="/privacy-policy"
      />
      <h1>Privacy policy</h1>
      <ListGroup>
        <ListGroupItem>
          <h2>1. Wat doet deze privacy policy?</h2>
          <p>
            Deze privacy policy regelt de verwerking van je persoonsgegevens als een onderdeel van
            je gebruik van onze website en de diensten die daarmee verband houden. Deze verwerking
            wordt uitgevoerd door {title} (met zetel te {street} {number}, {postalCode} {city}) voor
            de verwerking, in overeenstemming met de toepasselijke wetgeving inzake de bescherming
            van persoonsgegevens.
          </p>
          <p>
            Door het gebruik van onze website en/of onze diensten, erken je dat je deze Privacy
            Policy zorgvuldig hebt gelezen en dat je hiermee zonder voorbehoud instemt. Zulke
            wijziging zal via de website gecommuniceerd worden.
          </p>
          <p>
            Hou er rekening mee dat we zogenaamde ‘cookies’ of gelijkaardige technologie kunnen
            gebruiken als deel van de website en/of de diensten. Cookies zijn kleine tekstbestanden
            die geplaatst worden op de harde schijf van een toestel, en die bepaalde informatie
            bevatten, waaronder soms persoonsgegevens. Voor meer informatie betreffende ons gebruik
            van cookies, gelieve onze cookie policy te lezen.
          </p>
        </ListGroupItem>
        <ListGroupItem>
          <h2>2. Waarom verwerken jullie gegevens?</h2>
          <p>
            Wanneer je de website en/of diensten gebruikt, verwerken we persoonsgegevens die op jou
            betrekking hebben. Dit gebeurt onder meer voor volgende doeleinden:
          </p>
          <ul>
            <li>Als je onst contacteer via het contactformulier</li>
            <li>Bij het plaatsen van een bestelling</li>
          </ul>

          <p>
            Naast de bovengenoemde doeleinden kunnen wij je persoonlijke gegevens ook verwerken:
            <ul>
              <li>
                Om je op een gepersonaliseerde en efficiënte manier te voorzien van de informatie
                over producten en diensten die je aanvraagt, hetzij via de website, e-mail, telefoon
                of social media.
              </li>
              <li>
                Om je persoonsgegevens te verwerken zodat wij de diensten die we aanbieden kunnen
                verstrekken. Voor direct marketing doeleinden, d.w.z. om je te kunnen voorzien van
                gerichte communicatie, promoties, aanbiedingen en andere advertenties van ons of
                onze geselecteerde partners. Hiervoor zullen wij je voorafgaande toestemming vragen.
              </li>
              <li>
                Voor het uitvoeren van statistische analyses om onze website en/of diensten te
                verbeteren, of het ontwikkelen van nieuwe producten of diensten. (zie hiervoor ook
                meer info in onze cookiepolicy)
              </li>
              <li>
                Om te verstrekken aan een financiële instelling of betalingsdienstaanbieder, om uw
                financiële instelling en de betalingsdienstaanbieder in staat te stellen aan hun
                wettelijke verplichtingen te voldoen.
              </li>
              <li>
                Om over te dragen aan de politie of de gerechtelijke autoriteiten als bewijs van
                mogelijke misdrijven of indien er gegronde verdenkingen bestaan van een
                onrechtmatige daad of misdrijf door jou gepleegd door middel van je registratie bij
                of gebruik van de website of de diensten.
              </li>
              <li>
                In het kader van een mogelijke fusie met, overname van/door of splitsing door een
                derde partij, zelfs indien die derde zich buiten de EER bevindt.
              </li>
              <li>
                Als en wanneer je registratie op de website of gebruik van de website of diensten
                kan worden beschouwd (a) als een schending van de voorwaarden of de intellectuele
                eigendomsrechten of enig ander recht van een derde partij, (b) een bedreiging voor
                de veiligheid of integriteit van de diensten, (c) een gevaar voor de website of
                diensten of systemen van ons of van onze onderaannemers als gevolg van virussen,
                Trojaanse paarden, spyware, malware, of enige andere vorm van kwaadaardige code, of
                (d) op welke manier dan ook illegaal of onrechtmatig, discriminerend of beledigend
                is, mogen wij je gegevens verwerken in het belang van onszelf, onze partners of
                derden.
              </li>
            </ul>
          </p>
        </ListGroupItem>
        <ListGroupItem>
          <h2>3. Met wie delen jullie gegevens?</h2>
          <p>
            Wij verzenden je persoonsgegevens niet op een identificeerbare manier naar derden als
            dit niet vereist is om de diensten te verlenen, zonder je uitdrukkelijke toestemming
            daartoe.
          </p>
          <p>
            Wij kunnen een beroep doen op externe verwerkers om je de website en/of diensten aan te
            bieden. Wij zorgen ervoor dat derde verwerkers je persoonsgegevens alleen namens ons, en
            op schriftelijke instructie van ons, mogen verwerken. Wij garanderen dat alle externe
            verwerkers met de nodige zorgvuldigheid worden geselecteerd zodat wij kunnen rekenen op
            de veiligheid en integriteit van je persoonsgegevens.
          </p>
          <p>
            Wij kunnen geanonimiseerde en/of geaggregeerde gegevens overmaken aan andere
            organisaties die deze gegevens kunnen gebruiken om producten en diensten te verbeteren
            en de marketing, presentatie en verkoop van producten en diensten op maat te
            organiseren.
          </p>
        </ListGroupItem>
        <ListGroupItem>
          <h2>4. Waar verwerken jullie gegevens?</h2>
          <p>
            Wijzelf en onze externe verwerkers zullen je identificeerbare persoonsgegevens alleen in
            de EER verwerken.
          </p>
          <p>
            Wij kunnen je geanonimiseerde en/of geaggregeerde gegevens overdragen aan organisaties
            buiten de EER. Indien een dergelijke overdracht plaatsvindt, zullen wij ervoor zorgen
            dat er passende waarborgen zijn om de veiligheid en integriteit van je persoonlijke
            gegevens te garanderen, en dat alle rechten met betrekking tot persoonsgegevens
            gegarandeerd worden die je zou kunnen genieten onder toepasselijk dwingend recht.
          </p>
        </ListGroupItem>
        <ListGroupItem>
          <h2>5. Hoe verwerken jullie gegevens?</h2>
          <p>
            Wij zullen ons uiterste best doen om alleen de persoonsgegevens te verwerken die nodig
            zijn om de in deze privacy policy vermelde doeleinden te bereiken. Wij zullen je
            persoonsgegevens op een wettelijke, eerlijke en transparante manier verwerken. Wij
            zullen ons uiterste best doen om de persoonsgegevens accuraat en up-to-date te houden.
          </p>
          <p>
            Je persoonsgegevens worden alleen verwerkt zolang als nodig is om de in deze Privacy
            Policy vermelde doeleinden te bereiken of tot het moment waarop je je toestemming voor
            de verwerking ervan intrekt. Hou er rekening mee dat de intrekking van de toestemming
            kan impliceren dat je niet langer in staat bent om de website en/of diensten geheel of
            gedeeltelijk te gebruiken. Als je je bij onze website hebt geregistreerd, zullen wij je
            persoonsgegevens verwijderen als je je account verwijdert, tenzij een wettelijke of
            reglementaire verplichting of een gerechtelijk of administratief bevel ons dat zou
            verhinderen.
          </p>
          <p>
            Wij zullen de gepaste technische en organisatorische maatregelen nemen om je
            persoonsgegevens veilig te houden tegen ongeoorloofde toegang of diefstal en tegen
            onopzettelijk verlies, manipulatie of vernietiging. Toegang door ons personeel of
            personeel van onze externe verwerkers is alleen mogelijk op een need-to-know-basis en is
            onderworpen aan strikte geheimhoudingsverplichtingen. Je begrijpt echter dat de zorg
            voor veiligheid en beveiliging slechts inspanningsverplichtingen naar beste vermogen
            zijn, die nooit kunnen worden gegarandeerd.
          </p>
        </ListGroupItem>
        <ListGroupItem>
          <h2>6. Hoe lang bewaren jullie mijn gegevens?</h2>
          <p>
            De bewaartermijnen variëren afhankelijk van de aard van de verleende dienst. We bewaren
            je gegevens: zo lang als nodig voor de doeleinden waarvoor ze worden verzameld en
            verwerkt. zo lang ze nodig zijn om onze wettelijke, contractuele en juridische
            verplichtingen na te leven en te voldoen aan onze commerciële operationele activiteiten.
          </p>
        </ListGroupItem>
        <ListGroupItem>
          <h2>7. Wat zijn mijn rechten?</h2>
          <p>
            Je hebt het recht om toegang te vragen tot alle persoonsgegevens die wij over jou
            verwerken. Verzoeken om toegang die klaarblijkelijk worden ingediend met oog op het
            veroorzaken van overlast of schade voor ons, worden echter niet behandeld.
          </p>
          <p>
            Je hebt het recht om te vragen dat alle persoonsgegevens over jou die onjuist of
            onnauwkeurig zijn, kosteloos worden gecorrigeerd. Als je je hebt geregistreerd op onze
            website, kan je veel van deze gegevens zelf corrigeren via je account. Indien een
            dergelijk verzoek wordt ingediend, moet je bij dit verzoek ook het bewijs te voegen dat
            de persoonsgegevens waarvoor correctie wordt gevraagd, onjuist zijn.
          </p>
          <p>
            Je hebt het recht om je eerder gegeven toestemming voor de verwerking van je
            persoonsgegevens in te trekken. Je kan je toestemming ten allen tijde intrekken door een
            e-mail te sturen naar <a href={`mailto:${email}`}>{email}</a>, of door je account te
            verwijderen (indien van toepassing).
          </p>
          <p>
            Je hebt het recht om te vragen dat persoonsgegevens met betrekking tot jou worden
            verwijderd als deze niet langer nodig zijn in het licht van de doeleinden die in deze
            privacy policy worden uiteengezet of als je je toestemming voor de verwerking ervan
            intrekt. Je moet er echter rekening mee houden dat een verzoek tot verwijdering door ons
            zal worden beoordeeld in het licht van wettelijke of reglementaire verplichtingen of
            administratieve of gerechtelijke bevelen die ons kunnen verhinderen de betreffende
            persoonsgegevens te verwijderen.
          </p>
          <p>
            In de plaats van verwijdering kan je ook vragen dat wij de verwerking van je
            persoonsgegevens beperken indien (a) je de juistheid van die gegevens betwist, (b) de
            verwerking onwettig is of (c) de gegevens niet langer nodig zijn voor de genoemde
            doeleinden, maar je ze nodig hebt om jezelf te verdedigen in gerechtelijke procedures.
          </p>
          <p>
            Je hebt het recht om je te verzetten tegen de verwerking van persoonsgegevens als je kan
            aantonen dat er ernstige en gerechtvaardigde redenen zijn die verband houden met
            bijzondere omstandigheden en die een dergelijk verzet rechtvaardigen. Als de beoogde
            verwerking echter als direct marketing wordt aangemerkt, heb je het recht je kosteloos
            en zonder rechtvaardiging te verzetten tegen een dergelijke verwerking.
          </p>
          <p>
            Wanneer je persoonsgegevens worden verwerkt op basis van toestemming of op basis van een
            contract en de verwerking met geautomatiseerde middelen gebeurt, heb je het recht om de
            door jou aan ons verstrekte persoonsgegevens in een gestructureerd, algemeen gebruikt en
            machinaal leesbaar formaat te ontvangen en, indien technisch mogelijk, hebt u het recht
            deze gegevens rechtstreeks door te geven aan een andere dienstverlener. De technische
            haalbaarheid hiervan wordt uitsluitend beoordeeld door ons.
          </p>
          <p>
            Als je een verzoek wil indienen om een of meer van de hierboven vermelde rechten uit te
            oefenen, kan je een e-mail sturen naar <a href={`mailto:${email}`}>{email}</a>. In dit
            verzoek moet duidelijk worden vermeld welk recht je wenst uit te oefenen en waarom. Het
            moet ook gedateerd en ondertekend zijn en vergezeld gaan van een digitaal gescande kopie
            van je geldige identiteitskaart waaruit je identiteit blijkt. Wij zullen je onmiddellijk
            op de hoogte stellen van de ontvangst van dergelijk verzoek. Indien de aanvraag gegrond
            blijkt te zijn, zullen wij deze zo spoedig als redelijkerwijs mogelijk is en uiterlijk
            dertig (30) dagen na ontvangst van de aanvraag inwilligen.
          </p>
          <p>
            Als je een klacht hebt over de verwerking van je persoonsgegevens door ons, kan je
            altijd contact opnemen met onze geregistreerde DPO via het e-mailadres{' '}
            <a href={`mailto:${email}`}>{email}</a>. Blijf je ontevreden over ons antwoord, dan
            staat het je vrij om een klacht in te dienen bij de bevoegde
            gegevensbeschermingsautoriteit, de Belgische Gegevensbeschermingsautoriteit
            (Drukpersstraat 35, 1000 Brussel). Je kan hen telefonisch bereiken via{' '}
            <a
              href="tel:+32 (0)2 274 48
            00"
            >
              +32 (0)2 274 48 00
            </a>
            . Ga voor meer informatie naar{' '}
            <a
              href="https://www.gegevensbeschermingsautoriteit.be"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.gegevensbeschermingsautoriteit.be
            </a>
            .
          </p>
        </ListGroupItem>
      </ListGroup>
    </Container>
  );
}

export default Privacy;
